<template>
  <div class="category-scores-wrapper">
    <year-column v-for="year in riskData"
    :key="year.year"
    :yearData="year"
    :catIndex="catIndex">
    </year-column>
  </div>
</template>

<script>
import CategoryScoresYearColumn from './CategoryScoresYearColumn';

export default {
  name: 'category-scores-year-column',
  props: ['catIndex', 'riskData'],
  components: {
    'year-column': CategoryScoresYearColumn,
  },
};
</script>

<style>
  .category-scores-wrapper {
    display: flex;
    height: 26px;
    padding-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// CategoryScoresRow.vue?083afe0c